export const FONTS = [
  { name: "Georgia", family: "Georgia, serif", style: "serif" },
  { name: "Times New Roman", family: "'Times New Roman', serif", style: "serif" },
  { name: "Arial", family: "Arial, sans-serif", style: "sans-serif" },
  { name: "Helvetica", family: "Helvetica, sans-serif", style: "sans-serif" },
  { name: "Verdana", family: "Verdana, sans-serif", style: "sans-serif" },
  { name: "Trebuchet MS", family: "'Trebuchet MS', sans-serif", style: "sans-serif" },
  { name: "Courier New", family: "'Courier New', monospace", style: "monospace" },
  { name: "Brush Script MT", family: "'Brush Script MT', cursive", style: "script" },
  { name: "Comic Sans MS", family: "'Comic Sans MS', cursive", style: "casual" },
  { name: "Impact", family: "Impact, sans-serif", style: "display" },
  { name: "Palatino", family: "'Palatino Linotype', serif", style: "serif" },
  { name: "Garamond", family: "Garamond, serif", style: "serif" }
]

export function getFontFamily(fontName) {
  const font = FONTS.find(f => f.name === fontName)
  return font ? font.family : FONTS[0].family
}
